import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36be8776&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=36be8776&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be8776",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36be8776')) {
      api.createRecord('36be8776', component.options)
    } else {
      api.reload('36be8776', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36be8776&scoped=true", function () {
      api.rerender('36be8776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/institutional-trading/index.vue"
export default component.exports